var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-16",attrs:{"fluid":""}},[_c('h2',{staticClass:"text-h4 my-6"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-subtitle-2 mb-6"},[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }